import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PromotionViewer from './viewer';

@modal(
  {
    className: 'promotion-plan-viewer-modal',
  },
  true,
)
class PromotionViewerContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;

    return (
      <div className="promotion-plan-viewer">
        <div className="promotion-plan-viewer__header">
          {t(`cms.referral.promotion.modal.view_promotion.title`)}
          <CloseOutlined
            className="promotion-plan-viewer__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <div className="promotion-plan-viewer__body">
          <PromotionViewer viewPlan={this.props.viewPlan} />
        </div>

        <div className="promotion-plan-viewer__footer">
          <Button
            type="primary"
            size="large"
            className="promotion-plan-viewer__save-button"
            onClick={this.props.handleCloseModal}
          >
            {t('cms.referral.promotion.modal.btn.close')}
          </Button>
        </div>
      </div>
    );
  }
}

PromotionViewerContainer.propTypes = {
  t: PropTypes.func.isRequired,
  plan: PropTypes.object,
  handleCloseModal: PropTypes.func.isRequired,
};

PromotionViewerContainer.defaultProps = {
  t: () => {},
  plan: {},
  handleCloseModal: () => {},
};

export default PromotionViewerContainer;
